import moment from 'moment'


type DateType = string | Date
type DateRange = { from: DateType, to: DateType }

/**
 * Formates date iso string
 * e.g.:
 *  - '2077' → '2077-01-01T00:00:00.000Z'
 *  - new Date('2077') → '2077-01-01T00:00:00.000Z'
 */
const toISOString = (date: DateType): string => {
  if (date instanceof Date) {
    return date.toISOString()
  }

  return date && parseInt(date, 10) ? (new Date(Date.parse(date))).toISOString() : null
}

const format = (formatStr: string, isUTC: boolean) => (date: DateType): string => {
  const _date = isUTC ? moment.utc(date) : moment(date)
  return _date.format(formatStr)
}

/**
 * Formates date
 * e.g.:
 *  - null, 'MMM DD', false → null
 *  - new Date(2077, 6, 25, 12, 34), 'MMM DD', false → null
 */
const formatDate = (date: DateRange | DateType, formatStr: string, isUTC?: boolean): string => {
  const _format = format(formatStr, isUTC)

  if (!date) {
    return null
  }

  // TODO: number? Where the fuck is number came from?
  if (date instanceof Date || typeof date === 'string' || typeof date === 'number') {
    return _format(date)
  }

  if (typeof date === 'object' && date.from && date.to) {
    return `${_format(date.from)} - ${_format(date.to)}`
  }

  throw new Error('Wrong date format')
}


/**
 * Formates month or month range
 * @param date
 * @param isUTC
 */
const formatMonth = (date: DateRange | DateType, isUTC?: boolean): string => {
  if (!date) {
    return null
  }

  const monthFormat = 'MMMM YYYY'

  if (date instanceof Date || typeof date === 'string' || typeof date === 'number') {
    return format('MMMM YYYY', isUTC)(date)
  }

  const from = isUTC ? moment.utc(date.from) : moment(date.from)
  const to = isUTC ? moment.utc(date.to) : moment(date.to)

  if (!from.isSame(to, 'year')) {
    // different years
    return `${from.format(monthFormat)} - ${to.format(monthFormat)}`
  }

  if (!from.isSame(to, 'month')) {
    // different months
    return `${from.format('MMMM')} - ${to.format('MMMM YYYY')}`
  }

  return from.format(monthFormat)
}


export default {
  toISOString,
  formatDate,
  formatMonth,
}
